import React, { useState } from 'react';
import ReactPlayer from 'react-player';

const VideoPlayer = (props) => {
  // Player state
  const [playing, setPlaying] = useState(false);
  const [volume, setVolume] = useState(0.8);
  const [played, setPlayed] = useState(0);
  const [seeking, setSeeking] = useState(false);
  const [duration, setDuration] = useState(0);
  const [elapsed, setElapsed] = useState(0);
  const playerRef = React.useRef();

  const { data } = props;

  const sliderBackgroundChange = (state) => {
    const slider = document.getElementById('duration_slider');
    slider.style.cssText = `
          background: linear-gradient(90deg, rgb(226, 226, 226) ${state * 100}%, rgb(59, 107, 59) ${state * 100}%)
          `;
  };

  const handlePlayPause = () => {
    const playButton = document.getElementById('play_button');
    const pauseButton = document.getElementById('pause_button');
    if (playing === true) {
      setPlaying(false);
      pauseButton.style.display = 'none';
      playButton.style.display = 'inline-block';
    } else {
      setPlaying(true);
      playButton.style.display = 'none';
      pauseButton.style.display = 'inline-block';
    }
  };

  const handleVolumeLevel = (e) => {
    const { target } = e;
    setVolume(parseFloat(target.value));
    const slider = document.getElementById('volume_slider');
    slider.style.cssText = `
          background: linear-gradient(90deg, rgb(226, 226, 226) ${target.value * 100}%, rgb(59, 107, 59) ${target.value * 100}%)
          `;
  };

  const handleSeekMouseDown = () => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    const { target } = e;
    setPlayed(parseFloat(target.value));
    sliderBackgroundChange(target.value);
    playerRef.current.seekTo(parseFloat(target.value));
  };

  const handleSeekMouseUp = () => {
    setSeeking(false);
  };

  const handleProgress = (state) => {
    // We only want to update time slider if we are not currently seeking
    if (seeking === false) {
      setPlayed(state.played);
      setElapsed(state.playedSeconds);
      sliderBackgroundChange(state.played);
    }
  };

  const handleClickFullscreen = async () => {
    const container = document.getElementById('wrapper');
    const fullscreenApi = container.requestFullscreen
      || container.webkitRequestFullScreen
      || container.mozRequestFullScreen
      || container.msRequestFullscreen;
    if (!document.fullscreenElement) {
      fullscreenApi.call(container);
    } else {
      document.exitFullscreen();
    }
  };

  const handleDuration = (duration) => {
    setDuration(duration);
  };

  function fancyTimeFormat(recievedTime) {
    const hrs = Math.floor(recievedTime / 3600);
    const mins = Math.floor((recievedTime % 3600) / 60);
    const secs = Math.floor(recievedTime % 60);
    let time = '';
    if (hrs > 0) {
      time += `${hrs}:${(mins < 10 ? '0' : '')}`;
    }
    time += `${mins}:${(secs < 10 ? '0' : '')}`;
    time += secs;
    return time;
  }

  return (
    <div className="film-item">
      <div className="film-item__player">
        <div id="wrapper" className="player-wrapper">
          <div id="controls" className="controls">
            <a
              href=""
              id="play_button"
              title="Play"
              onClick={(e) => {
                e.preventDefault();
                handlePlayPause();
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 3.79214C0 0.863688 3.10426 -0.95627 5.5667 0.528516L19.1789 8.73638C21.607 10.2004 21.607 13.7996 19.1789 15.2636L5.5667 23.4715C3.10426 24.9563 0 23.1363 0 20.2079V3.79214Z"
                  fill="white"
                />
              </svg>
            </a>
            <a
              href=""
              id="pause_button"
              style={{ display: 'none' }}
              title="Pause"
              onClick={(e) => {
                e.preventDefault();
                handlePlayPause();
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.221214 1.092C1.41561e-07 1.51867 0 2.07867 0 3.2V20.8C0 21.92 1.41561e-07 22.48 0.221214 22.908C0.416674 23.2842 0.728324 23.5899 1.1115 23.7813C1.54579 24 2.11579 24 3.25714 24H3.52857C4.66857 24 5.23857 24 5.67421 23.7827C6.0576 23.5909 6.36927 23.2847 6.5645 22.908C6.78571 22.4813 6.78571 21.9213 6.78571 20.8V3.2C6.78571 2.08 6.78571 1.52 6.5645 1.092C6.36927 0.715343 6.0576 0.409138 5.67421 0.217333C5.23993 1.39078e-07 4.66993 0 3.52857 0H3.25714C2.11714 0 1.54714 1.39078e-07 1.1115 0.217333C0.728117 0.409138 0.416444 0.715343 0.221214 1.092ZM12.4355 1.092C12.2143 1.51867 12.2143 2.07867 12.2143 3.2V20.8C12.2143 21.92 12.2143 22.48 12.4369 22.908C12.632 23.284 12.9431 23.5897 13.3258 23.7813C13.7601 24 14.3301 24 15.4714 24H15.7429C16.8829 24 17.4529 24 17.8885 23.7827C18.2714 23.5906 18.5826 23.2845 18.7774 22.908C19 22.4813 19 21.9213 19 20.8V3.2C19 2.08 19 1.52 18.7788 1.092C18.5836 0.715343 18.2719 0.409138 17.8885 0.217333C17.4542 1.39078e-07 16.8842 0 15.7429 0H15.4714C14.3314 0 13.7614 1.39078e-07 13.3258 0.217333C12.9429 0.409364 12.6304 0.715546 12.4355 1.092Z"
                  fill="white"
                />
              </svg>
            </a>
            <input
              className="ranger_player duration_slider"
              id="duration_slider"
              type="range"
              min={0}
              max={0.999999}
              step="any"
              value={played}
              onMouseDown={handleSeekMouseDown}
              onChange={handleSeekChange}
              onMouseUp={handleSeekMouseUp}
            />
            <input
              className="ranger_player volume_slider"
              id="volume_slider"
              type="range"
              min={0}
              max={1}
              step="any"
              value={volume}
              onChange={handleVolumeLevel}
            />
            <span>
              {fancyTimeFormat(elapsed)}
              /
              {fancyTimeFormat(duration)}
            </span>
            <a
              href=""
              id="fullscreen"
              title="Fullscreen"
              onClick={(e) => {
                e.preventDefault();
                handleClickFullscreen();
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 2H4C2.89543 2 2 2.89543 2 4V8"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
                <path
                  d="M22 8V4C22 2.89543 21.1046 2 20 2H16"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
                <path
                  d="M16 22H20C21.1046 22 22 21.1046 22 20V16"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
                <path
                  d="M8 22H4C2.89543 22 2 21.1046 2 20V16"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
              </svg>
            </a>
          </div>
          <ReactPlayer
            className="react-player"
            id="player"
            url={data.src}
            controls={false}
            width="100%"
            height="auto"
            config={{
              file: {
                attributes: {
                  controlsList: 'nodownload',
                },
              },
            }}
            playing={playing}
            volume={volume}
            onProgress={handleProgress}
            ref={playerRef}
            onDuration={handleDuration}
          />
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;
